import styled, {css} from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { JackpotThemeType } from "../../../../../../services/jackpots-with-state/jackpots-with-state.service.interface";

interface IJackpotWidgetCollectingAmountBox{
    forcePCView: boolean;
    widgetIsMinimized?: boolean;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const JackpotWidgetCollectingAmountDefaultBox = styled.div<IJackpotWidgetCollectingAmountBox>`
    font-family: ${({theme}) => theme.font.family.bold};
    color: ${({theme}) => theme.colors.brandSecondary};

    width: ${({widgetIsMinimized}) => widgetIsMinimized ? "100%" : "38%" };
    text-align: ${({widgetIsMinimized}) => widgetIsMinimized ? "center" : "right" };
    font-size: ${({widgetWidth, widgetIsMinimized}) => {
        if (widgetIsMinimized) {
            /** In minimized view at a widget width of 375px, the amount should be of font-size 9px */
            return widgetWidth * 12 / 375 + "px";
        }
        /** In desktop view at a widget width of 468px, the amount should be of font-size 15px */
        return widgetWidth * 25 / 468 + "px";
    }};
    ${({forcePCView, widgetWidth, theme}) => !forcePCView ? css`
        @media ${theme.mediaQuery.mAndBelow} {
            text-align: center;
            width: 100%;
            /** In mobile view at a widget width of 131px, the amount should be of font-size 9px */
            font-size: ${widgetWidth * 12 / 131 + "px"};
        }
    ` : null}
`;

const JackpotWidgetCollectingAmountCasino777Box = styled(JackpotWidgetCollectingAmountDefaultBox)`
    color: ${({theme, themeType}) => themeType === JackpotThemeType.Light ? theme.colors.danger : theme.colors.brandSecondary};
`;

export const JackpotWidgetCollectingAmountBox = styledByTheme(JackpotWidgetCollectingAmountDefaultBox)
    .forCasino777(JackpotWidgetCollectingAmountCasino777Box).apply();
